import { MAX_PAYMENT, MIN_PAYMENT } from '~/src/constants';
import { TAppThunkDispatch, TGetState } from '~/src/store';

import { EValidityStatus, setPaymentSumValidity, TPaymentSumValidity } from '../actionCreators';

import validateBonusesValue from './validateBonusesValue';

// TODO - подозрение на избыточность этих данных в сторе, валидацию суммы можно перенести в селектор
const validatePaymentSum = (validationResult?: TPaymentSumValidity) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const {
            loyalty: { info: { bonuses: availableBonuses } },
            payment: { paymentData: { paymentSum, isUseBonuses, bonusesValue, isConnectAutoPay } },
        } = getState();

        if (validationResult) {
            dispatch(setPaymentSumValidity(validationResult));
        } else {
            const maxPaymentSum = isUseBonuses ? MAX_PAYMENT + Math.min(availableBonuses, bonusesValue) : MAX_PAYMENT;
            const minPaymentSum = isConnectAutoPay ? 0 : MIN_PAYMENT;

            const getValidationStatus = (): TPaymentSumValidity => {
                switch (true) {
                    case paymentSum > maxPaymentSum:
                        return {
                            isValid: EValidityStatus.IS_UPPER_BOUND_ERROR,
                            maxPaymentSum,
                        };
                    case paymentSum < minPaymentSum:
                        return {
                            isValid: EValidityStatus.IS_LOWER_BOUND_ERROR,
                            minPaymentSum,
                        };
                    case (paymentSum <= maxPaymentSum) && (paymentSum >= minPaymentSum):
                    default:
                        return {
                            isValid: EValidityStatus.IS_VALID,
                        };
                }
            };

            dispatch(setPaymentSumValidity(getValidationStatus()));
        }

        if (isUseBonuses) {
            dispatch(validateBonusesValue());
        }
    };
};

export default validatePaymentSum;
